import Vue from "vue";
import { ActionTree, MutationTree } from "vuex";
import { RootState } from "@/store/types";
import { Question, Survey } from "@/store/modules/lib";

export interface State {
  surveys: Survey[];
  loadStatus: string;
}

const defaultState: State = {
  surveys: [],
  loadStatus: "",
};

const getters = {
  surveys: (state: State) => state.surveys,
  surveyById: (state: State) => (id: string) =>
    state.surveys.find((survey: Survey) => survey._id == id),
};

const mutations: MutationTree<State> = {
  loading(state: State) {
    state.loadStatus = "loading";
    state.surveys = [];
  },
  setup(state: State, surveys: Survey[]) {
    state.loadStatus = "shrads success";
    state.surveys = surveys;
  },
  error(state: State) {
    state.loadStatus = "error";
    state.surveys = [];
  },
  deleteQuestion(state: State, questions: Question[]) {
    state.surveys[0].questions = [...questions];
  },
};

const actions: ActionTree<State, RootState> = {
  deleteQuestion({ commit, state }, questionId) {
    const questions = this.state.survey.surveys[0].questions;
    const indexOfQstToDelete = questions
      .map((question: Question) => question.id)
      .indexOf(questionId);
    questions.splice(indexOfQstToDelete, 1);
    commit("deleteQuestion", questions);
  },
  load({ commit }, { exhibitor }) {
    return new Promise((resolve, reject) => {
      commit("loading");
      Vue.axios({
        url: "/query",
        method: "POST",
        data: `
          {
            "query": "query{Surveys(_exhibitor:\\"${exhibitor}\\"){ count values { _id  title questions {  answerTitle help id important  order specify  text  type  answers { id sense type order value includeQuestions } }  } }}",
            "variables": {}
          }
        `,
      })
        .then((resp: any) => {
          if (resp.data.status == "ok") {
            commit("setup", resp.data.data.Surveys.values);
            resolve({ surveys: resp.data.data.Surveys.values });
            // return resp.data.data.Surveys.values.surveys;
          } else {
            reject(resp);
          }
        })
        .catch((err: any) => {
          commit("error");
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
